export default __webpack_public_path__ + "static/media/Background_00178.0d552756.png";